<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :table="table"
      :pagination="pagination"
      resource="commission_settlement_applications"
    />
  </div>
</template>

<script type="text/javascript">
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import { COMMISSION_SETTLEMENT_STATUS } from '@/constants';
import _ from 'lodash';

@Component
export default class CommissionSettlementApplications extends Vue {
  table = { data: [] }
  pagination = {}

  filter = [
    {
      prop: 'serial_no_cont',
      label: '单号',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'user_no_cont',
      label: '用户名唯一编号',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'user_nickname_cont',
      label: '用户名',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'status_in',
      label: '状态',
      form: {
        component: 'select',
        props: {
          multiple: true,
          options: _.map(COMMISSION_SETTLEMENT_STATUS, (label, value) => ({ label, value }))
        }
      }
    }
  ]

  get columns() {
    return createColumns({
      handleTransferSuccess: this.fetchData,
      handleRejectSuccess: this.fetchData
    });
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/commission_settlement_applications', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
